module.exports = __webpack_public_path__ + "static/media/home__review-submit.666ead2e.png";